import PagesDrillDownTableContainer from './PagesDrillDownTableContainer'
import PagesDrillDownTable from './PagesDrillDownTable'
export { PagesDrillDownTable }
export { PagesDrillDownTableContainer }
export default PagesDrillDownTableContainer



// WEBPACK FOOTER //
// ./src/components/PagesDrillDownTable/index.js